import { useQuery } from '@tanstack/react-query';
import { api } from './client';
import { DashboardChartsResponse } from './types';

export interface DashboardChartsParams {
  period?: '12m' | '6m' | 'ytd' | 'mtd';
  organization_id?: string;
}

/**
 * Hook to fetch spend trends and vendor concentration charts from GET /api/v2/dashboard/charts/
 */
export function useDashboardCharts(params: DashboardChartsParams = { period: '12m' }) {
  return useQuery<DashboardChartsResponse>({
    queryKey: ['dashboard-charts', params],
    queryFn: async () => {
      const response = await api.get<DashboardChartsResponse>('/v2/dashboard/charts/', {
        params,
      });
      return response.data;
    },
    staleTime: 60 * 1000, // 1 minute
  });
}
